import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import './Navigation.scss'

const Navigation = ({
  firstStep,
  nextLinkPath,
  nextStepTitle,
  previousStepTitle,
  previousLinkPath,
  projectTitle,
}) => (
  <nav className="c-project-step-navigation">
    {!firstStep && (
      <Link
        className={classnames({
          'button--primary': true,
          'button--secondary': true,
          'c-project-step-navigation__link': true,
          'c-project-step-navigation__link--previous': true,
        })}
        aria-label={previousStepTitle}
        to={previousLinkPath}
        data-on="click"
        data-event-category={projectTitle}
        data-event-action="Clicked Step Navigation"
      />
    )}
    <Link
      className="button--primary c-project-step-navigation__link--next"
      to={nextLinkPath}
      data-on="click"
      data-event-category={projectTitle}
      data-event-action="Clicked Step Navigation"
    >
      {nextStepTitle}
    </Link>
  </nav>
)

Navigation.propTypes = {
  firstStep: PropTypes.bool.isRequired,
  nextLinkPath: PropTypes.string.isRequired,
  nextStepTitle: PropTypes.string.isRequired,
  previousStepTitle: PropTypes.string,
  previousLinkPath: PropTypes.string.isRequired,
  projectTitle: PropTypes.string.isRequired,
}

export default Navigation
